import { Box, CardContent, Typography } from "@mui/material";
import { motion } from "framer-motion";
import React from "react";
import { fadeIn } from "../../utils/motion";

const AboutStatement = () => {
  return (
    <Box className="container-box">
      <motion.div variants={fadeIn("down", "tween", 0.2, 1)}>
        <CardContent>
          <Typography
            variant="h3"
            fontWeight={500}
            align="center"
            sx={{
              backgroundImage: `linear-gradient(44deg , #00ff00 ,#61dafb,  #0000ff )`,
              color: "transparent",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontWeight: "bolder",
              width: "100%",
              textTransform: "uppercase",
            }}
          >
            gugulethu projects
          </Typography>
          <Typography
            variant="body2"
            sx={{ mb: "2vh" }}
            className="mt-[24px] font-normal sm:text-[24px] text-[18px] sm:leading-[45px] leading-[39px] text-white"
          >
            Iguguempire project company is a trustworthy company and we provide
            all the best for our clients.
          </Typography>
          <Typography
            variant="body2"
            className="mt-[24px] font-normal sm:text-[24px] text-[18px] sm:leading-[45px] leading-[39px] text-white"
          >
            we do instant lawn , paving tar surfacing, building, pool
            renovations and painting. Feel free to contact us anytime,
            iguguempie is always available to assist you.
          </Typography>
        </CardContent>
      </motion.div>
    </Box>
  );
};

export default AboutStatement;
